angular.module('rjmNg.directives').directive "tourRemover", [() ->
  restrict: "A"
  priority: -1
  link: (scope, element, attrs, controller) ->
    numberOfItems = element.parents('.js-tour').find('.js-repeat-tour-items').length

    # only happens if there's more than one chart on dash
    if numberOfItems > 0

      tourSteps = element.find('.js-tour-step')

      # this runs through all the tour steps and removes the attributes
      # from the DOM on everything but the first chart
      for step in tourSteps
        stepDataset = step.dataset 
      
        unless scope.dashboardItem.column is 0 and scope.dashboardItem.row is 0
          delete stepDataset?.intro
          delete stepDataset?.step
]
